import React, { useState, memo } from "react";
import ImageModalComponent from "../ImageModalComponent/ImageModalComponent";

const KnowledgeBaseItem = memo(({ item }) => {
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsImageModalOpen(true);
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false);
    setSelectedImage(null);
  };

  return (
    <div className="forum_card">
      <div className="forum_card_details p-2">
        {item.EmployeeImage ? (
          <div>
            <img
              src={item.EmployeeImage}
              alt="Avatar"
              style={{
                width: "50px",
                height: "50px",
                objectFit: "cover",
                borderRadius: "50%",
                cursor: "pointer",
              }}
              onClick={() => openImageModal(item.EmployeeImage)}
            />
          </div>
        ) : (
          <div
            style={{
              width: "50px",
              height: "50px",
              backgroundColor: "#ddd",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "50%",
            }}
          >
            <i className="bi bi-person-circle" style={{ fontSize: "30px" }}></i>
          </div>
        )}
        <h5>{item.UploadedBy || ""}</h5>
      </div>

      <div className="forum_card-contain">
        <div className="forum_card-contain-one">
          <h6 className="p-0">
            <b>{item.Name || ""}</b> <span style={{ color: "#9D9D9D" }}>|</span>{" "}
            <span className="forum-card-date-time">
              <i className="bi bi-calendar-check"></i>{" "}
              {new Date(item.CreatedDate).toLocaleDateString("en-US", {
                month: "short",
                day: "2-digit",
              })}{" "}
              |{" "}
              {new Date(item.CreatedDate).toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </span>
          </h6>
          <p className="mb-1">
            <a
              href={item.FilePath || ""}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "inherit",
                textDecoration: "none",
                cursor: "pointer",
              }}
              className="text-primary"
            >
              {item.Name || ""}
            </a>{" "}
            has been uploaded by {item.UploadedBy || ""}.
          </p>
        </div>
      </div>

      <ImageModalComponent
        isOpen={isImageModalOpen}
        imageUrl={selectedImage}
        onClose={closeImageModal}
      />
    </div>
  );
});

export default KnowledgeBaseItem;
